import Placeholder from "@assets/images/placeholderSmLogo.png";
import {
  Card,
  CardContent,
  CardMedia,
  Container,
  Typography
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { AnnouncementList_announcements_edges_node } from "@saleor/announcements/types/AnnouncementList";
import TablePagination from "@saleor/components/TablePagination";
import { maybe, renderCollection } from "@saleor/misc";
import { ListActions, ListProps } from "@saleor/types";
import React from "react";

interface AnnouncementThumbmailListProps extends ListProps, ListActions {
  announcements?: AnnouncementList_announcements_edges_node[];
  onAdd?();
}

const AnnouncementThumbmailList: React.FC<AnnouncementThumbmailListProps> = props => {
  const {
    announcements,
    onRowClick,
    disabled,
    settings,
    pageInfo,
    onNextPage,
    onPreviousPage,
    onUpdateListSettings
  } = props;

  const useStyles = makeStyles(
    {
      container: {
        display: "grid",
        gap: "25px",
        gridTemplateColumns: "33% 33% auto",
        gridTemplateRows: "auto auto auto",
        margin: 0,
        maxWidth: "inherit",
        padding: "32px 40px 32px 40px"
      },
      content: {
        padding: 0
      },
      emptycard: {
        alignContent: "center",
        alignSelf: "center",
        gridColumnEnd: 4,
        gridColumnStart: 1,
        gridRowEnd: 4,
        gridRowStart: 1,
        margin: 0,
        width: "100%"
      },
      entry: {
        borderRadius: 15,
        cursor: "pointer",
        justifyContent: "center",
        width: "inherit"
      },
      image: {
        borderTopLeftRadius: 15,
        borderTopRightRadius: 15,
        height: 255
      },
      paginate: {
        "& .MuiTableCell-root": {
          width: "100%"
        },
        display: "flex",
        maxWidth: "inherit"
      },
      title: {
        color: "primary",
        display: "flex",
        fontWeight: 600,
        justifyContent: "center",
        margin: 25
      },
      titlecontainer: {
        alignContent: "center",
        display: "flex"
      }
    },
    { name: "AnnouncementThumbmailList" }
  );

  const classes = useStyles(props);

  return (
    <>
      <Container className={classes.container}>
        {renderCollection(
          announcements,
          (entry, index) => (
            <Card
              id={`thumbnail${index}`}
              key={maybe(() => entry.id)}
              className={classes.entry}
              onClick={entry ? onRowClick(entry.id) : undefined}
            >
              <CardContent className={classes.content}>
                <CardMedia
                  id={`thumbnailImage${index}`}
                  component="img"
                  image={entry.image ? entry.image.url : Placeholder}
                  className={classes.image}
                />
                <div id={`thumbnailTitle${index}`}>
                  <Typography className={classes.title}>
                    {entry.title.length > 140
                      ? `${entry.title.substring(0, 140)}...`
                      : entry.title}
                  </Typography>
                </div>
              </CardContent>
            </Card>
          ),
          () => (
            <Card className={classes.emptycard}>
              <CardContent>
                <Typography />
                No Announcement Found
                <Typography />
              </CardContent>
            </Card>
          )
        )}
      </Container>
      <div className={classes.paginate}>
        <TablePagination
          settings={settings}
          hasNextPage={pageInfo && !disabled ? pageInfo.hasNextPage : false}
          onNextPage={onNextPage}
          onUpdateListSettings={onUpdateListSettings}
          hasPreviousPage={
            pageInfo && !disabled ? pageInfo.hasPreviousPage : false
          }
          choices={[9]}
          onPreviousPage={onPreviousPage}
          colSpan={4}
        />
      </div>
    </>
  );
};

AnnouncementThumbmailList.displayName = "AnnouncementThumbmailList";
export default AnnouncementThumbmailList;
